import React, { useMemo } from 'react';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TPButton from 'components/TP-UI/TPButton';
import TPGrid from 'components/TP-UI/TPGrid';
import EnableMfaForm from '../EnableMfaForm';
import { REDUX_FORM_DEFAULT_CONFIG } from 'constants/form';
import { MFA_TYPE, MFA_TYPE_OPTIONS } from '../../../../constants';
import MfaTypes from '../MfaTypes';
import TPTypography from 'components/TP-UI/TPTypography';
import { required } from 'utils/validation/fieldValidationRules';

const EnableMfa = ({
  form,
  type = MFA_TYPE.AUTH_APP,
  allowedTypes,
  phoneNumber,
  mfaTypeRequired = false,
  setupPhoneRequired = false,
  sendSmsRequired = false,
  qrCode,
  secret,
  error,
  onCodeExpired,
  onChangeMfa,
  submitFailed,
  handleSubmit,
  button,
  loading,
  onCodeSent,
}) => {
  const { t } = useTranslation('auth');

  const mfaOptions = useMemo(
    () => MFA_TYPE_OPTIONS.filter((opt) => allowedTypes?.includes(opt.value)),
    [allowedTypes],
  );
  const selectedOpt = mfaOptions.find((o) => o.value === type);

  return (
    <form onSubmit={handleSubmit} noValidate>
      {mfaTypeRequired ? (
        <Field
          name="type"
          component={MfaTypes}
          allowedTypes={allowedTypes}
          onChange={onChangeMfa}
          required
          validate={[required]}
        />
      ) : (
        <>
          {allowedTypes?.length > 1 ? (
            <TPTypography variant="h6" gutterBottom>
              {t(selectedOpt?.label)}
            </TPTypography>
          ) : null}
          <EnableMfaForm
            form={form}
            error={error}
            submitFailed={submitFailed}
            type={type}
            phoneNumber={phoneNumber}
            setupPhoneRequired={setupPhoneRequired}
            sendSmsRequired={sendSmsRequired}
            allowResend={false}
            qrCode={qrCode}
            secret={secret}
            onCodeSent={onCodeSent}
            onCodeExpired={onCodeExpired}
          />
          {button ? (
            button
          ) : (
            <TPGrid container justifyContent="flex-end">
              <TPGrid item>
                <TPButton loading={loading} primary size="large" type="submit">
                  {t('signUp.confirmPhone.verify')}
                </TPButton>
              </TPGrid>
            </TPGrid>
          )}
        </>
      )}
    </form>
  );
};

EnableMfa.propTypes = {
  form: PropTypes.string.isRequired,
  type: PropTypes.oneOf([...Object.values(MFA_TYPE), '']),
  allowedTypes: PropTypes.array,
  phoneNumber: PropTypes.string,
  mfaTypeRequired: PropTypes.bool,
  setupPhoneRequired: PropTypes.bool,
  sendSmsRequired: PropTypes.bool,
  qrCode: PropTypes.string,
  secret: PropTypes.string,
  button: PropTypes.node,
  onSubmit: PropTypes.func,
  onCodeExpired: PropTypes.func,
  onChangeMfa: PropTypes.func,
  onCodeSent: PropTypes.func,
  loading: PropTypes.bool,
};

export default reduxForm({
  ...REDUX_FORM_DEFAULT_CONFIG,
  enableReinitialize: true,
})(EnableMfa);
